import UiTable from '@/components/UiTable'
import UiTableColumn from '@/components/UiTableColumn'
import UiTablePanel from '@/components/UiTablePanel'
import UiSlider from '@/components/UiSlider'
import UiColorPicker from '@/components/UiColorPicker'
import UiPagination from '@/components/UiPagination'
import UiTooltip from '@/components/UiTooltip'
import UiProgress from '@/components/UiProgress'
import UiAlert from '@/components/UiAlert'
import UiEmpty from '@/components/UiEmpty'
import UiPopover from '@/components/UiPopover'
import UiDropdown from '@/components/UiDropdown'
import UiCollapse from '@/components/UiCollapse'
import UiCollapseItem from '@/components/UiCollapseItem'
import UiImage from '@/components/UiImage'
import UiAvatar from '@/components/UiAvatar'
import UiCarousel from '@/components/UiCarousel'
import UiCalendar from '@/components/UiCalendar'
import UiTimeline from '@/components/UiTimeline'
import UiButton from '@/components/UiButton'
import UiMotionList from '@/components/UiMotionList'
import UiSlidingIndicator from '@/components/UiSlidingIndicator'
import UiActionRow from '@/components/UiActionRow'
import UiButtonGroup from '@/components/UiButtonGroup'
import UiCheckbox from '@/components/UiCheckbox'
import UiCheckboxGroup from '@/components/UiCheckboxGroup'
import UiColorFilter from '@/components/UiColorFilter'
import UiCompactSectionCard from '@/components/UiCompactSectionCard'
import UiControlGroup from '@/components/UiControlGroup'
import UiCountBadge from '@/components/UiCountBadge'
import UiDatePicker from '@/components/UiDatePicker'
import UiDialog from '@/components/UiDialog'
import UiDrawer from '@/components/UiDrawer'
import UiFormDialog from '@/components/UiFormDialog'
import UiFormDivider from '@/components/UiFormDivider'
import UiFormNotice from '@/components/UiFormNotice'
import UiIconControl from '@/components/UiIconControl'
import UiImageUpload from '@/components/UiImageUpload'
import UiInfoTile from '@/components/UiInfoTile'
import UiInput from '@/components/UiInput'
import UiMultiSelect from '@/components/UiMultiSelect'
import UiNavigationButton from '@/components/UiNavigationButton'
import UiNumberInput from '@/components/UiNumberInput'
import UiPageToolbar from '@/components/UiPageToolbar'
import UiSegmentedControl from '@/components/UiSegmentedControl'
import UiSectionCard from '@/components/UiSectionCard'
import UiSelect from '@/components/UiSelect'
import UiStickyActions from '@/components/UiStickyActions'
import UiSwitch from '@/components/UiSwitch'
import UiTabButton from '@/components/UiTabButton'
import UiTabPane from '@/components/UiTabPane'
import UiTabs from '@/components/UiTabs'
import UiTag from '@/components/UiTag'
import UiTimePicker from '@/components/UiTimePicker'
import UiTransfer from '@/components/UiTransfer'

const components = [
  UiTablePanel,
  UiActionRow,
  UiButton,
  UiMotionList,
  UiSlidingIndicator,
  UiButtonGroup,
  UiCheckbox,
  UiCheckboxGroup,
  UiColorFilter,
  UiCompactSectionCard,
  UiControlGroup,
  UiCountBadge,
  UiDatePicker,
  UiDialog,
  UiDrawer,
  UiFormDialog,
  UiFormDivider,
  UiFormNotice,
  UiIconControl,
  UiImageUpload,
  UiInfoTile,
  UiInput,
  UiMultiSelect,
  UiNavigationButton,
  UiNumberInput,
  UiPageToolbar,
  UiSegmentedControl,
  UiSectionCard,
  UiSelect,
  UiStickyActions,
  UiSwitch,
  UiTabButton,
  UiTabs,
  UiTag,
  UiTimePicker,
  UiTransfer
]

export default {
  install (Vue) {
    components.forEach(component => Vue.component(component.name, component))
    // 内部名称必须保持 ElTabPane，业务模板仍统一使用 UiTabPane。
    Vue.component('UiTabPane', UiTabPane)
    // 直接继承 Element 本体，显式别名保留内部父子分发协议。
    Vue.component('UiTable', UiTable)
    Vue.component('UiTableColumn', UiTableColumn)
    Vue.component('UiSlider', UiSlider)
    Vue.component('UiColorPicker', UiColorPicker)
    Vue.component('UiPagination', UiPagination)
    Vue.component('UiTooltip', UiTooltip)
    Vue.component('UiProgress', UiProgress)
    Vue.component('UiAlert', UiAlert)
    Vue.component('UiEmpty', UiEmpty)
    Vue.component('UiPopover', UiPopover)
    Vue.component('UiDropdown', UiDropdown)
    Vue.component('UiCollapse', UiCollapse)
    Vue.component('UiCollapseItem', UiCollapseItem)
    Vue.component('UiImage', UiImage)
    Vue.component('UiAvatar', UiAvatar)
    Vue.component('UiCarousel', UiCarousel)
    Vue.component('UiCalendar', UiCalendar)
    Vue.component('UiTimeline', UiTimeline)
  }
}
